import { render, staticRenderFns } from "./CphSidebar.vue?vue&type=template&id=19057c9c&"
import script from "./CphSidebar.vue?vue&type=script&lang=js&"
export * from "./CphSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CphSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports